/** 与 equipmentData / getDeviceInfo 一致：0 USB、1 BT、2 2.4G */
export function isRhythmWirelessWorkMode(
  workMode: string | number | undefined | null
): boolean {
  if (workMode === undefined || workMode === null) return false;
  if (workMode === 2 || workMode === "2") return true;
  const s = String(workMode).trim().toLowerCase();
  return s === "2.4g" || s.includes("2.4");
}

/** 有线 / USB：~31fps（SDK 建议 30–60fps） */
export const RHYTHM_SEND_INTERVAL_USB_MS = 32;

/**
 * 2.4G / 蓝牙（贝盈、星闪等）：50ms ≈ 20fps，对齐 SDK 无线模式建议上限。
 */
export const RHYTHM_SEND_INTERVAL_WIRELESS_MS = 50;

/**
 * 华奋达 2.4G 新协议（lightingVersion=1）：~30fps，对齐 SDK「建议 30–60fps」。
 */
export const RHYTHM_SEND_INTERVAL_HFD_WIRELESS_MS = 33;

/** 华奋达 2.4G 旧无线协议（lightingVersion=0） */
export const RHYTHM_SEND_INTERVAL_HFD_WIRELESS_LEGACY_MS = 48;

/** 916 / 8815 setGifLight：916 设备（M71 等） */
export const RHYTHM_SEND_INTERVAL_BEIYING_916_MS = 10;

/** 8815 X98-1K setGifLight：378 字节整平面下发，按约 12.5fps 控制 HID 压力 */
export const RHYTHM_SEND_INTERVAL_BEIYING_8815_X98_MS = 80;

/** @deprecated 使用 BEIYING_916 / BEIYING_8815_X98 分项常量 */
export const RHYTHM_SEND_INTERVAL_BEIYING_9168815_MS =
  RHYTHM_SEND_INTERVAL_BEIYING_916_MS;

export type RhythmSendIntervalHint = {
  workMode?: string | number | undefined | null;
  solutionRovider?: string | null;
  lightingVersion?: number | null;
  hfdLightingVersion?: number | null;
  /** 贝盈 916 有线 setGifLight（M71/M80 等） */
  usesBeiying916GifLight?: boolean;
  /** 贝盈 8815 X98-1K setGifLight */
  usesBeiying8815X98GifLight?: boolean;
  /** 兼容旧字段：任一 916/8815 */
  usesBeiying9168815GifLight?: boolean;
};

export function resolveRhythmHardwareSendIntervalForTargets(
  targets: RhythmSendIntervalHint[]
): number {
  let anyBeiying8815X98 = false;
  let anyBeiying916 = false;
  let anyWireless = false;
  let anyHfdWirelessRgb = false;
  let anyHfdWirelessLegacy = false;
  for (const t of targets) {
    if (t.usesBeiying8815X98GifLight) anyBeiying8815X98 = true;
    if (t.usesBeiying916GifLight || t.usesBeiying9168815GifLight) {
      anyBeiying916 = true;
    }
    if (!isRhythmWirelessWorkMode(t.workMode)) continue;
    anyWireless = true;
    if (String(t.solutionRovider ?? "") === "huafenda") {
      anyHfdWirelessRgb = true;
      const lv = Number(t.hfdLightingVersion ?? t.lightingVersion ?? 0);
      if (lv !== 1) anyHfdWirelessLegacy = true;
    }
  }
  if (anyBeiying8815X98) return RHYTHM_SEND_INTERVAL_BEIYING_8815_X98_MS;
  if (anyBeiying916) return RHYTHM_SEND_INTERVAL_BEIYING_916_MS;
  if (anyHfdWirelessRgb) {
    if (anyHfdWirelessLegacy)
      return RHYTHM_SEND_INTERVAL_HFD_WIRELESS_LEGACY_MS;
    return RHYTHM_SEND_INTERVAL_HFD_WIRELESS_MS;
  }
  if (anyWireless) return RHYTHM_SEND_INTERVAL_WIRELESS_MS;
  return RHYTHM_SEND_INTERVAL_USB_MS;
}

export function resolveRhythmHardwareSendIntervalMs(
  workModes: Array<string | number | undefined | null>
): number {
  return resolveRhythmHardwareSendIntervalForTargets(
    workModes.map((workMode) => ({ workMode }))
  );
}
